import { useRef, useState } from 'react';
import { MainCard } from 'ui/components/main-card';
import { useTranslation } from 'translations/hooks';
import { ContentHeader } from 'ui/components/content-header';
import { TunnelHeader } from './components/header';
import { SegmentList } from './components/segment-list';
import {
  TunnelScanner,
  type TunnelScannerHandle,
} from './components/tunnel-scanner';
import { useAutoSync } from './hooks/use-auto-sync';
import { useRings } from 'business/tunnel/pages/ring-scan/hooks/use-virtual-rings';
import { VIRTUAL_RINGS } from 'business/tunnel/pages/ring-scan/constants';

export const TunnelPage = () => {
  useAutoSync();
  const { t } = useTranslation();
  const scannerRef = useRef<TunnelScannerHandle>(null);
  const { rings, lastRealRingNumber } = useRings();
  const [explicitRingId, setExplicitRingId] = useState<string | null>(null);
  const selectedRingId =
    explicitRingId ?? rings[rings.length - 1 - VIRTUAL_RINGS]?.id ?? null;
  const selectedRing = rings.find((r) => r.id === selectedRingId) ?? null;

  return (
    <ContentHeader title={t('tunnel.title')} className="w-full gap-3 px-4 py-1">
      <TunnelHeader
        rings={rings}
        lastRealRingNumber={lastRealRingNumber}
        selectedRingId={selectedRingId}
        onRingChange={(ringId) => {
          setExplicitRingId(ringId);
          scannerRef.current?.resetAndFocus();
        }}
      />
      <MainCard smBottom>
        <TunnelScanner ref={scannerRef} ring={selectedRing} />
        <div className="my-4" />
        <SegmentList
          ringId={selectedRingId}
          ringNumber={selectedRing?.number ?? null}
          onAfterDeleteClose={() => scannerRef.current?.resetAndFocus()}
        />
      </MainCard>
    </ContentHeader>
  );
};
